module.exports = __webpack_public_path__ + "img/Logo.fe0db7c5.png";